"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.UnifiedConfig = void 0;




class UnifiedConfig {









  constructor() {
    this.callbacks = {};
    this.clientPortals = [];
    this.options = {
      autoLogout: true,
      autoRefresh: true
    };
  }
}exports.UnifiedConfig = UnifiedConfig;